var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { APIService } from 'App/services/api';
import { personalFields } from 'App/order-fields';
import { hasLocalStorageAccess } from 'App/pwa';
import { LS_SAVED_ORDER_DATA } from 'Comps/OrderForm/OrderFormHelpers';
import { getSafeLsJSON } from './parsers';
var customerLsKey = 'saved-customer';
var personalFieldsKeys = personalFields.map(function (field) { return field.name; });
var fromFormData = function (values) { return ({
    id: values.id || undefined,
    name: values.customer_firstname,
    surname: values.customer_lastname,
    email: values.email,
    phone: values.phone,
}); };
var toFormData = function (customer) { return ({
    id: customer.id || undefined,
    customer_firstname: customer.name,
    customer_lastname: customer.surname,
    email: customer.email,
    phone: customer.phone,
}); };
var getSavedCustomerData = function (formValues) {
    var customerData = getSafeLsJSON(customerLsKey, null);
    if (customerData) {
        return toFormData(customerData);
    }
    var customerDataFromLastOrder = formValues || getSafeLsJSON(LS_SAVED_ORDER_DATA, {});
    var fieldsToPass = __spreadArray(__spreadArray([], __read(personalFieldsKeys), false), ['id', 'is_activated'], false);
    return getFields(customerDataFromLastOrder, fieldsToPass);
};
var createCustomer = function (customerData) {
    return APIService.post('/customers', customerData).then(function (response) {
        return response.json();
    });
};
var saveCustomerLocally = function (customer, saveId) {
    if (saveId === void 0) { saveId = false; }
    if (hasLocalStorageAccess()) {
        var currentCustomer = getSavedCustomerData();
        var customerToSave = saveId
            ? customer
            : getFields(customer, Object.keys(customer).filter(function (f) { return f !== 'id'; }));
        localStorage.setItem(customerLsKey, JSON.stringify(__assign(__assign({}, currentCustomer), customerToSave)));
    }
};
var verifyCustomer = function (customer, code) {
    return APIService.post("/customers/".concat(customer.id, "/verify"), {
        code: code,
    }).then(function (response) { return response.json(); });
};
function getFields(obj, fields) {
    var entries = Object.entries(obj);
    return Object.fromEntries(entries.filter(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return fields.includes(key);
    }));
}
var CustomerService = {
    createCustomer: createCustomer,
    fromFormData: fromFormData,
    getSavedCustomerData: getSavedCustomerData,
    saveCustomerLocally: saveCustomerLocally,
    verifyCustomer: verifyCustomer,
};
export default CustomerService;
